import React from "react";
import { useDimensions } from "hooks/useDimension";
import {
  Home,
  HorizontalScrollable,
  TradicaoMigrante,
  SandaliaValente,
} from "components";
import * as S from "./styles";

export const Main: React.FC = () => {
  const { width } = useDimensions();

  return (
    <HorizontalScrollable snapAlign="none" enableHandling={width > 1010}>
      <S.SectionWrapper className="home">
        <Home />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <TradicaoMigrante />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <SandaliaValente />
      </S.SectionWrapper>
    </HorizontalScrollable>
  );
};
